import React, { lazy, Suspense } from 'react'
import Preloader from './Preloader'

const Content = lazy(() => import('./Content'))

function MarketPage() {
    return (
        <Suspense fallback={<Preloader />}>
            <Content />
        </Suspense>
    )
}

export default MarketPage
